import { render, staticRenderFns } from "./domainNamerParsing.vue?vue&type=template&id=c281a2be&"
import script from "./domainNamerParsing.vue?vue&type=script&lang=js&"
export * from "./domainNamerParsing.vue?vue&type=script&lang=js&"
import style0 from "./domainNamerParsing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports